<template>
  <main class="tariffs">
    <div class="tariffs__container">
      <div class="tariffs__row">
        <h1 class="tariffs__title">Тарифы</h1>
        <div
          class="tariffs__info"
          v-if="tariffInfo"
          v-html="tariffInfo"
        />
      </div>
      <div class="tariffs__group">
        <button
          class="tariffs__subtitle"
          v-bind:class="{ active: specificationBlock }"
          v-on:click="specificationBlock = !specificationBlock"
          type="button"
        >
          Нет скрытых платежей. Весь функционал входит в тариф
        </button>
        <ul v-if="specificationBlock">
          <li>Расписание клиники</li>
          <li>База пациентов</li>
          <li>Лист ожидания</li>
          <li>Электронная медицинская карта</li>
          <li>Интерактивная зубная формула</li>
          <li>Шаблоны документов для пациента</li>
          <li>Шаблоны протоколов приема</li>
          <li>Планы лечения</li>
          <li>Задачи</li>
          <li>Отчеты</li>
        </ul>
      </div>
      <div class="tariffs__table-basic">
        <div class="tariffs__table-basic__header">
          <div class="tariffs__table-basic__row">
            <div>Количество кресел</div>
            <div>1</div>
            <div>2</div>
            <div>3</div>
            <div>4</div>
            <div>5+</div>
          </div>
        </div>
        <div class="tariffs__table-basic__body">
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 3 мес. (Цена без скидки)</div>
            <div class="tariffs__table-basic__cell tariff-cell">12 600 ₽</div>
            <div class="tariffs__table-basic__cell tariff-cell">15 000 ₽</div>
            <div class="tariffs__table-basic__cell tariff-cell">16 500 ₽</div>
            <div class="tariffs__table-basic__cell tariff-cell">18 000 ₽</div>
            <div class="tariffs__table-basic__cell tariff-cell">19 500 ₽</div>
          </div>
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 6 мес. (Скидка 10%)</div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>22 680 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>2 520 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>27 000 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>3 000 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>29 700 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>3 300 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>32 400 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>3 600 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>35 100 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>3 900 ₽</span></p>
            </div>
          </div>
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 12 мес. (Скидка 20%)</div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>40 320 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>10 080 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>48 000 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>12 000 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>52 800 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>13 200 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>57 600 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>14 400 ₽</span></p>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>62 400 ₽</span>
              <p class="tariff-cell__saving-money">Экономия <span>15 600 ₽</span></p>
            </div>
          </div>
        </div>
      </div>
      <h2 class="tariffs__caption">Дополнительные модули</h2>
      <button
        class="tariffs__subtitle"
        v-bind:class="{ active: cashboxBlock }"
        v-on:click="cashboxBlock = !cashboxBlock"
        type="button"
      >
        Онлайн-касса
      </button>
      <div v-if="cashboxBlock" class="tariffs__table-cashbox">
        <div class="tariffs__table-cashbox__header">
          <div>Срок доступа</div>
          <div>3 месяца</div>
          <div>6 месяцев</div>
          <div>12 месяцев</div>
          <div>24 месяца</div>
        </div>
        <div class="tariffs__table-cashbox__body">
          <div>Стоимость</div>
          <div data-label="3 месяца">
            1 300&#8381;/мес.<br>
            <span>3 900&#8381;/3 мес.</span>
          </div>
          <div data-label="6 месяцев">
            1 150&#8381;/мес.<br>
            <span>6 900&#8381;/6 мес.</span>
          </div>
          <div data-label="12 месяцев">
            920&#8381;/мес.<br>
            <span>11 040&#8381;/12 мес.</span>
          </div>
          <div data-label="24 месяцев">
            800&#8381;/мес.<br>
            <span>19 200&#8381;/24 мес.</span>
          </div>
        </div>
      </div>
      <button
        class="tariffs__subtitle"
        v-bind:class="{ active: smsBlock }"
        v-on:click="smsBlock = !smsBlock"
        type="button"
      >
        Модуль &#171;Sms-рассылки&#187;
      </button>
      <div v-if="smsBlock">
        <div class="tariffs__description">
          Напоминайте вашим клиентам о предстоящем приёме, информируйте об акциях,
          поздравляйте с праздниками.<br><br>
          Чтобы отправлять sms от имени вашей клиники, необходимо зарегистрировать
          имя отправителя.
          <br>
          У операторов Мегафон и МТС это платная услуга.
        </div>
        <h3 class="tariffs__text">
          Стоимость SMS
        </h3>
        <div class="tariffs__units">
          <tariff-appointment
            v-for="(tariff, key) in smsMailings.tariffs"
            v-bind:key="key"
            v-bind:caption="tariff.caption"
            v-bind:price="tariff.price"
            bold-caption
          />
          <tariff-appointment
            caption="Персональное имя отправителя"
            v-bind:price="5200"
            priceCurrency="₽/мес"
            bold-caption
          />
          <div class="tariffs__unit">
            <p class="tariffs__unit__caption">Имя отправителя 32top</p>
            <p class="tariffs__unit__price">Бесплатно</p>
          </div>
        </div>
      </div>
      <button
        class="tariffs__subtitle"
        v-bind:class="{ active: uisBlock }"
        v-on:click="uisBlock = !uisBlock"
        type="button"
      >
        Телефония
      </button>
      <div v-if="uisBlock">
        <div class="tariffs__units">
          <div class="tariffs__unit">
            <p class="tariffs__unit__price">По тарифам оператора</p>
          </div>
        </div>
      </div>
      <button
        class="tariffs__subtitle"
        v-bind:class="{ active: egisBlock }"
        v-on:click="egisBlock = !egisBlock"
        type="button"
      >
        ЕГИСЗ
      </button>
      <div v-if="egisBlock">
        <div class="tariffs__description">
          <a
            href="https://mis-help.32top.ru/ru/projects/mis/instructions/start_work/egisz"
            target="_blank"
            rel="noopener noreferrer">
            Как подключить клинику к ЕГИСЗ
          </a>
        </div>
        <div class="tariffs__units">
          <div class="tariffs__unit">
            <p class="tariffs__unit__price">Бесплатно</p>
          </div>
        </div>
      </div>
      <button
        class="tariffs__subtitle"
        v-bind:class="{ active: whatsBlock }"
        v-on:click="whatsBlock = !whatsBlock"
        type="button"
      >
        WhatsApp
      </button>
      <div v-if="whatsBlock">
        <div class="tariffs__units">
          <div class="tariffs__unit">
            <p class="tariffs__unit__price">1000&#8381;/мес </p>
          </div>
        </div>
      </div>
      <support-contacts
        title="Для подключения услуги свяжитесь с нами удобным способом"
        class="tariffs__support"
      >
        <modal-dialog
          max-width="90%"
          v-bind:title="orderConsultationTitle"
          v-model="isShowOrderConsultationForm"
          width="400px"
          with-cross
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="tariffs__support__btn"
              type="button"
              v-on="listenerObject"
            >Заказать консультацию</button>
          </template>
          <div
            class="tariffs__modal__content"
            v-if="isOrderSended"
          >
            <span class="tariffs__modal__caption">{{ orderConsultationMessage }}</span>
          </div>
          <form
            class="tariffs__modal__content"
            v-else
            v-on:submit.prevent="onSubmitOrderConsultation"
          >
            <input-text
              placeholder="Введите ФИО"
              title="ФИО"
              v-bind:violations="orderConsultationFullNameViolations"
              v-letter-capital
              v-model="orderConsultationFullName"
            />
            <input-phone
              v-model="orderConsultationPhone"
              v-bind:violations="orderConsultationPhoneViolations"
            />
            <button
              class="tariffs__modal__btn"
              type="submit"
              v-bind:disabled="disableOrderConsultationButton"
            >Заказать</button>
          </form>
        </modal-dialog>
      </support-contacts>
    </div>
  </main>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';
import SupportContacts from '@/components/SupportContacts.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import { OrderConsultationRequest } from '@/storage/gateways/TariffGateway';
import InputPhone from '@/components/InputPhone.vue';
import InputText from '@/components/InputText.vue';
import notifierMixin from '@/mixins/notifierMixin';

const TariffAppointment = {
  functional: true,
  name: 'TariffAppointment',
  props: {
    price: {
      type: Number,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
    boldCaption: {
      type: Boolean,
      default: () => false,
    },
    priceCurrency: {
      type: String,
      default: () => '₽',
    },
  },
  render(createElement, { props }) {
    const subtitleElement = createElement(
      'p',
      { class: props.boldCaption ? 'tariffs__unit__caption' : 'tariffs__unit__subtitle' },
      props.caption,
    );
    const priceElement = createElement(
      'p',
      { class: 'tariffs__unit__price' },
      `${props.price} ${props.priceCurrency}`,
    );
    return createElement(
      'article',
      { class: 'tariffs__unit' },
      [subtitleElement, priceElement],
    );
  },
};

/**
 * @description Время показа уведомления об успешно отправленной заявке.
 * @type {number}
 */
const SHOW_SUCCESS_NOTIFICATION_TIMEOUT = 3000;

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.orderConsultationViolations ? vm.orderConsultationViolations[cause] : []
);

/**
 * @description Примесь заказа консультации.
 * @type {Vue}
 */
const orderConsultationMixin = {
  computed: {
    /**
     * @description Деактивировать кнопку отправки.
     * @type {boolean}
     */
    disableOrderConsultationButton() {
      return this.isOrderConsultationAwaitRequest;
    },
    orderConsultationFullNameViolations: resolveInputErrors('full-name'),
    orderConsultationPhoneViolations: resolveInputErrors('phone'),
    /**
     * @description Заголовок диалога заказа консультации.
     * @type {string}
     */
    orderConsultationTitle() {
      if (this.isOrderSended) {
        return '';
      }
      return 'Заполните данные, и наш менеджер свяжется с вами в ближайшее время';
    },
  },
  data() {
    return {
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isOrderConsultationAwaitRequest: false,
      /**
       * @description Показывать форму.
       * @type {boolean}
       */
      isShowOrderConsultationForm: false,
      /**
       * @description ФИО.
       * @type {string}
       */
      orderConsultationFullName: '',
      /**
       * @description Сообщение о заявке на консультацию.
       * @type {string}
       */
      orderConsultationMessage: '',
      /**
       * @description Телефон.
       * @type {string}
       */
      orderConsultationPhone: '',
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      orderConsultationViolations: {},
      /**
       * @description Заявка отправлена.
       * @type {boolean}
       */
      isOrderSended: false,
    };
  },
  methods: {
    /**
     * @description Обработать заказ консультации.
     * @returns {void}
     */
    onSubmitOrderConsultation() {
      const request = new OrderConsultationRequest(
        this.orderConsultationFullName,
        this.orderConsultationPhone,
      );
      this.isOrderConsultationAwaitRequest = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.orderConsultationViolations = error.allCauses();
      };
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.orderConsultationFullName = '';
        this.orderConsultationMessage = message;
        this.orderConsultationPhone = '';
        this.orderConsultationViolations = {};
        this.isOrderSended = true;
        setTimeout(
          () => { this.isShowOrderConsultationForm = false; },
          SHOW_SUCCESS_NOTIFICATION_TIMEOUT,
        );
      };
      this
        .$tariffGateway
        .orderConsultation(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isOrderConsultationAwaitRequest = false; });
    },
  },
};

/**
 * @description Примесь тарифа клиники
 * @type {any}
 */
const clinicTariffInfoMixin = {
  data() {
    return {
      /**
       * @description Текст с информацией о тарифе
       * @type {null|String}
       */
      tariffInfo: null,
    };
  },
  methods: {
    /**
     * @description Получить информацию о тарифе
     */
    fetchTariffInfo() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (tariffInfo) => {
        this.tariffInfo = tariffInfo;
      };
      this
        .$tariffGateway
        .getTariffInfo()
        .then((result) => result.fold(onFail, onSuccess));
    },
  },
};

export default {
  name: 'ClinicPanelTariffs',
  components: {
    TariffAppointment,
    ModalDialog,
    SupportContacts,
    InputPhone,
    InputText,
  },
  created() {
    this.fetchTariffInfo();
  },
  data() {
    return {
      specificationBlock: false,
      cashboxBlock: false,
      smsBlock: false,
      uisBlock: false,
      egisBlock: false,
      whatsBlock: false,
      /**
       * Список тарифов на рассылки смс
       */
      smsMailings: {
        tariffs: [
          { price: 5, caption: '1 SMS' },
        ],
      },
    };
  },
  mixins: [aboutMixin, notifierMixin, orderConsultationMixin, clinicTariffInfoMixin],
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.text__violation {
  margin-bottom: 0 !important;
}
.tariffs {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  &__container {
    width: min(100%,1220px);
    padding: 38px 20px 200px 23px;
  }
  &__row {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 40px 0;
  }
  &__info {
    border: 1px solid #C2CFE0;
    background: transparent;
    border-radius: 4px;
    padding: 10px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: #000000;
    font-family: 'Lato', sans-serif;
    span {
      color: #EF474C;
    }
  }
  &__group {
    ul {
      margin: 0 0 30px 0;
    }
  }
  &__table-basic {
    display: flex;
    flex-direction: column;
    border: 1px solid #C2CFE0;
    margin: 0 0 50px 0;
    overflow: auto;
    &__header {
      min-width: 995px;
      font-weight: 600;
      font-size: 20px;
      line-height: 29px;
      .tariffs__table-basic__row {
        &:last-child {
          border-top: 1px solid #C2CFE0;
        }
      }
    }
    &__body {
      min-width: 995px;
      .tariffs__table-basic__row {
        border-top: 1px solid #C2CFE0;
      }
    }
    &__row {
      display: grid;
      grid-template-columns: 1.8fr repeat(5, 1fr);
      text-align: center;
      div {
        border-right: 1px solid #C2CFE0;
        padding: 10px;
      }
      div:first-child {
        text-align: left;
        color: black;
      }
      div:last-child {
        border-right: none;
      }
    }
    &__cell {
      display: grid;
      align-items: center;
      gap: 5px;
      &.tariff-cell {
        color: #0489E0;
        p {
          display: block;
        }
      }
      .tariff-cell {
        &__saving-money {
          font-size: 14px;
          color: #546C85;
          span {
            white-space: nowrap;
          }
        }
      }
    }
  }
  &__table-cashbox {
    margin: 0 0 30px 0;
    max-width: 870px;
    width: 100%;
    &__header,
    &__body {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
      div {
        padding: 10px;
      }

    }
    &__header {
      border-bottom: 2px solid #0489E0;
      div {
        font-weight: 600;
      }
    }
    &__body {
      div:first-child {
        font-weight: 600;
      }
      div span {
        color: #90A0B7;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }
  &__caption {
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    cursor: pointer;
    margin: 0 0 20px 0;
  }
  &__subtitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    margin: 0 0 20px 0;
    max-width: 550px;
    width: 100%;
    text-align: left;
    &:after {
      content: '';
      background-image: url("@/assets/img/checked/arrow-top-blue.svg");
      background-repeat: no-repeat;
      background-position: center;
      width: 30px;
      height: 30px;
      margin: 0 0 0 20px;
    }
    &.active:after {
      transform: rotate(180deg);
    }
  }
  &__text {
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    margin: 0 0 20px 0;
  }
  &__units {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 33px;
    margin: 0 0 64px 0;
  }
  &__unit {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    border: 1px solid #C2CFE0;
    border-radius: 6px;
    gap: 10px;
    p {
      margin: 0;
    }
    &__caption {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
    }
    &__price {
      font-weight: 400;
      font-size: 32px;
      line-height: 38px;
      color: #0489E0;
      span {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
  &__description {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #323C47;
    margin: 0 0 33px 0;
    a:hover {
      text-decoration: none;
    }
  }
  &__support {
    margin: 60px 0 0 0;
    .support-contacts__right {
      gap: 10px;
    }
    &__btn {
      @include buttons.btn-blue(100%, 56px, 22px);
      border-radius: 6px;
      max-width: 333px;
    }
  }
  &__modal {
    &__caption {
      font-size: 1.25rem;
      font-weight: 500;
      letter-spacing: .0125em;
      text-align: center;
    }
    &__content {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &__btn {
      margin: 30px auto 0;
      @include buttons.btn-blue(100%, 48px, 16px);
      background-color: #0489E0 !important;
      color: #FFFFFF !important;
      height: 46px !important;
    }
  }
}
@media screen and (max-width: 1360px) {
  .tariffs {
    &__container {
      width: 100%;
      padding: 40px 20px 100px 20px;
    }
  }
}
@media screen and (max-width: 700px) {
  .tariffs {
    &__table-cashbox {
      &__header {
        display: none;
      }
      &__body {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 0 0 20px 0;
        div {
          display: flex;
          justify-content: space-between;
          text-align: right;
          padding: 0;
          &:first-child {
            display: none;
          }
          &:before {
            content: attr(data-label);
            font-weight: 700;
            margin-right: 20px;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
  }

}
@media screen and (max-width: 640px) {
  .tariffs {
    &__container {
      padding: 40px 10px 140px;
    }
  }
}

</style>
